<template>
  <div>
    <v-card elevation="5" style="height: 800px; overflow-y: scroll">
      <v-toolbar color="primary" dark>
        <v-btn
          icon
          @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ `${currentFilterPosition + 1}/${currentFilterTotal} :: ${currentArtwork.name === '' ? $t('artwork.no_name') : currentArtwork.name}` }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn v-if="isLabelPrinterEnabled" icon
            @click="print()">
            <v-icon>
              mdi-printer
            </v-icon>
          </v-btn>
          <v-btn v-if="currentExportBox && !currentArtwork.isInExportBox" icon color="#6eff63"
            @click="addArtworkToExportBox()">
            <v-icon>
              mdi-archive-plus
            </v-icon>
          </v-btn>
          <v-btn v-if="currentExportBox && currentArtwork.isInExportBox" icon color="#ff5d17"
            @click="removeArtworkFromExportBox()">
            <v-icon>
              mdi-archive-minus
            </v-icon>
          </v-btn>
          <v-divider vertical>
          </v-divider>
          <v-btn
            icon
            :disabled="!isPreviousEnabled"
            @click="previous()">
            <v-icon>mdi-arrow-left-bold</v-icon>
          </v-btn>
          <v-btn
            icon
            :disabled="!isNextEnabled"
            @click="next()">
            <v-icon>mdi-arrow-right-bold</v-icon>
          </v-btn>
          <v-btn v-if="isNotLink"
            icon
            :disabled="!isAnyChange"
            @click="saveArtwork">
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container>
        <v-row>
          <v-col cols='12'>
            <v-tabs v-model="currentTab" center-active show-arrows="">
              <v-tab> {{ $t('tabs.common') }} </v-tab>
              <v-tab v-if="isNotLink"> {{ $t('tabs.description') }} </v-tab>
              <v-tab v-if="isNotLink"> {{ $t('tabs.opinion') }} </v-tab>
              <v-tab v-if="isNotLink"> {{ $t('tabs.details') }} </v-tab>
              <v-tab v-if="isNotLink"> {{ $t('tabs.photos') }} </v-tab>
              <v-tab v-if="isNotLink"> {{ $t('tabs.attachments') }} </v-tab>
              <v-tab-item class="py-5 px-5">
                <v-row>
                  <v-col cols="6">
                    <Thumbnail
                      class="pa-2"
                      :fileId="currentArtwork == null ? -1 : currentArtwork.thumbnailFileId"
                      :width="null"
                      :height="450">
                    </Thumbnail>
                  </v-col>
                  <v-col md="6" sd="12">
                    <v-select
                      v-model="currentArtwork.type"
                      :items="artworkTypeList"
                      item-text="name"
                      item-value="id"
                      return-object
                      :label="$t('fields.type')"
                      :readonly="!isNotLink"
                      @change="onChange">
                    </v-select>
                    <v-text-field
                      v-model="currentArtwork.evidenceNumber"
                      :readonly="!isNotLink"
                      :label="$t('fields.evidenceNumber')"
                      counter="128"
                      @input="onChange">
                    </v-text-field>
                    <v-text-field
                      v-model="currentArtwork.name"
                      :readonly="!isNotLink"
                      :label="$t('fields.name')"
                      counter="128"
                      @input="onChange">
                    </v-text-field>
                    <v-combobox
                      v-model="currentArtwork.authors"
                      :readonly="!isNotLink"
                      :items="authorList"
                      :label="$t('fields.authors')"
                      item-text="name"
                      item-value="id"
                      multiple
                      chips
                      @change="onChange">
                    </v-combobox>
                    <v-combobox
                      v-if="false"
                      v-model="currentArtwork.styles"
                      :readonly="!isNotLink"
                      :items="styleList"
                      :label="$t('fields.styles')"
                      item-text="name"
                      item-value="id"
                      multiple
                      chips
                      @change="onChange">
                    </v-combobox>
                    <v-combobox
                      v-model="currentArtwork.themes"
                      :items="themeList"
                      :readonly="!isNotLink"
                      :label="$t('fields.themes')"
                      item-text="name"
                      item-value="id"
                      multiple
                      chips
                      @change="onChange">
                    </v-combobox>
                    <v-combobox
                      v-model="currentArtwork.techniques"
                      :items="techniqueList"
                      :readonly="!isNotLink"
                      :label="$t('fields.techniques')"
                      item-text="name"
                      item-value="id"
                      multiple
                      chips
                      @change="onChange">
                    </v-combobox>
                    <v-combobox
                      v-model="currentArtwork.materials"
                      :items="materialList"
                      :readonly="!isNotLink"
                      :label="$t('fields.materials')"
                      item-text="name"
                      item-value="id"
                      multiple
                      chips
                      @change="onChange">
                    </v-combobox>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item class="py-5 px-5">
                <v-select
                  v-model="currentArtwork.datingType"
                  :label="$t('fields.dating')"
                  :items="this.datingItems"
                  item-value="id"
                  item-text="text"
                  @change="onChange">
                </v-select>
                <v-text-field
                  v-model="currentArtwork.datingYear"
                  v-if="currentArtwork.datingType == 1"
                  type="number"
                  :label="$t('fields.year')"
                  @change="onChange">
                </v-text-field>
                <v-text-field
                  v-model="currentArtwork.datingYearFrom"
                  v-if="currentArtwork.datingType == 2"
                  type="number"
                  :label="$t('fields.year_from')"
                  @change="onChange">
                </v-text-field>
                <v-text-field
                  v-model="currentArtwork.datingYearTo"
                  v-if="currentArtwork.datingType == 2"
                  type="number"
                  :label="$t('fields.year_to')"
                  @change="onChange">
                </v-text-field>
                <v-textarea
                  v-model="currentArtwork.description"
                  :label="$t('fields.description')"
                  @input="onChange">
                </v-textarea>
              </v-tab-item>
              <v-tab-item class="py-5 px-5">
                <v-text-field
                  v-model="currentArtwork.acquisitionsYear"
                  type="number"
                  :label="$t('fields.acquisitionsYear')"
                  @change="onChange">
                </v-text-field>
                <v-text-field
                  v-model="currentArtwork.acquisitionsOrigin"
                  :label="$t('fields.acquisitionsOrigin')"
                  @input="onChange">
                </v-text-field>
                <v-textarea
                  v-model="currentArtwork.opinionDescription"
                  :label="$t('fields.opinion')"
                  @input="onChange">
                </v-textarea>
              </v-tab-item>
              <v-tab-item class="py-5 px-5">
                <PricesEditor
                  @onChange="onChange">
                </PricesEditor>
                <v-combobox
                  v-model="computedStandardLocation"
                  :items="locationsList"
                  item-text="name"
                  item-value="name"
                  clearable
                  clear-icon="mdi-close-circle-outline"
                  append-icon="mdi-map-marker-outline"
                  :label="$t('fields.standardLocation')"
                  @change="onChange">
                </v-combobox>
                <v-combobox
                  v-model="computedCurrentLocation"
                  :items="locationsList"
                  item-text="name"
                  item-value="name"
                  clearable
                  clear-icon="mdi-close-circle-outline"
                  append-icon="mdi-map-marker-outline"
                  :label="$t('fields.currentLocation')"
                  @change="onChange">
                </v-combobox>
                <v-subheader>
                  {{ $t('fields.dimensions') }}
                </v-subheader>
                <DimensionsEditor
                  @onChange="onChange">
                </DimensionsEditor>
              </v-tab-item>
              <v-tab-item class="py-5 px-5">
                  <PhotoGallery
                    @onChange="onChange">
                  </PhotoGallery>
              </v-tab-item>
              <v-tab-item class="py-5 px-5">
                  <AttachmentList
                    @onChange="onChange">
                  </AttachmentList>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
      <confirm-dialog :show-dialog="this.isShowDiscardEdit"
        confirm-color="warning"
        :question-text="$t('common_actions.confirm_discard_edit')"
        :positive-text="$t('common_actions.yes')"
        :negative-text="$t('common_actions.no')"
        @onCancel="onCancelDiscardEdit"
        @onConfirm="onConfirmDiscardEdit">
      </confirm-dialog>
    </v-card>
    <v-snackbar color="error"
      v-model="printErrorShow">
      {{ $t('artwork.print_label_error') }}
    </v-snackbar>
    <v-snackbar color="success"
      v-model="printSuccessShow">
      {{ $t('artwork.print_label_success') }}
    </v-snackbar>
  </div>
</template>

<script>
import CommonComboEdit from '@/components/common/CommonComboEdit.vue'
import DimensionsEditor from '@/components/dimensions/DimensionsEditor.vue'
import DateTextField from '@/components/common/DateTextField.vue'
import Thumbnail from '@/components/common/Thumbnail'
import i18n from '@/plugins/i18n'
import PricesEditor from '@/components/prices/PricesEditor.vue'
import PhotoGallery from '@/components/gallery/PhotoGallery.vue'
import AttachmentList from '@/components/attachments/AttachmentList.vue'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import ClientAppService from '@/services/clientApp/ClientAppService'

export default {
  components: { CommonComboEdit, DimensionsEditor, Thumbnail, DateTextField, PricesEditor, PhotoGallery, AttachmentList, ConfirmDialog },
  data () {
    return {
      printSuccessShow: false,
      printErrorShow: false,
      confirmDiscardEditCallback: null,
      isShowDiscardEdit: false,
      currentTab: 0,
      datingItems: [
        { id: 0, text: i18n.t('dating.unknown') },
        { id: 1, text: i18n.t('dating.exact') },
        { id: 2, text: i18n.t('dating.interval') }
      ]
    }
  },
  computed: {
    computedStandardLocation: {
      get: function () {
        return this.currentArtwork.standardLocation
      },
      set: function (newValue) {
        if (typeof newValue === 'object') {
          this.currentArtwork.standardLocation = newValue ? newValue.name : ''
        } else {
          this.currentArtwork.standardLocation = newValue
        }
      }
    },
    computedCurrentLocation: {
      get: function () {
        return this.currentArtwork.currentLocation
      },
      set: function (newValue) {
        if (typeof newValue === 'object') {
          this.currentArtwork.currentLocation = newValue ? newValue.name : ''
        } else {
          this.currentArtwork.currentLocation = newValue
        }
      }
    },
    isLabelPrinterEnabled () {
      return this.$store.getters['localSettings/isLabelPrinterEnabled']
    },
    artworkTypeList () {
      return this.$store.getters['artworkTypes/artworkTypesList']
    },
    authorList () {
      return this.$store.getters['authors/authorsList']
    },
    techniqueList () {
      return this.$store.getters['techniques/techniquesList']
    },
    materialList () {
      return this.$store.getters['materials/materialsList']
    },
    styleList () {
      return this.$store.getters['styles/stylesList']
    },
    themeList () {
      return this.$store.getters['themes/themesList']
    },
    currentFilterTotal () {
      return this.$store.getters['artworks/currentFilterTotal']
    },
    currentFilterPosition () {
      return this.$store.getters['artworks/currentFilterPosition']
    },
    currentArtwork () {
      return this.$store.getters['artworks/currentArtwork']
    },
    isPreviousEnabled () {
      return this.currentFilterPosition > 0
    },
    isNextEnabled () {
      return this.currentFilterPosition + 1 < this.currentFilterTotal
    },
    isAnyChange () {
      return this.$store.getters['artworks/isAnyChange']
    },
    locationsList () {
      return this.$store.state.locations.locationsList
    },
    currentExportBoxId () {
      return this.$store.getters['exportBoxes/currentExportBoxId']
    },
    currentExportBox () {
      return this.$store.getters['exportBoxes/currentExportBox']
    },
    isNotLink () {
      return this.$store.getters['authentication/accessType'] > 1
    },
    dimensionList () {
      return this.$store.getters['dimensions/dimensionsList']
    }
  },
  methods: {
    setAcquisitionDate (value) {
      console.log(value)
    },
    onChange () {
      this.$store.commit('artworks/SET_IS_ANY_CHANGE', true)
      this.$emit('onArtworkChange')
    },
    saveArtwork () {
      this.$store.dispatch('artworks/saveCurrentArtworkData').then(_ => {
        this.$emit('onSaveSuccess')
      }, error => {
        this.$emit('onSaveError', error.response.data)
      })
    },
    previous () {
      if (this.isAnyChange) {
        this.confirmDiscardEditCallback = this.performPrevious
        this.isShowDiscardEdit = true
        return
      }

      this.performPrevious()
    },
    performPrevious () {
      this.$emit('onPrevious')
    },
    next () {
      if (this.isAnyChange) {
        this.confirmDiscardEditCallback = this.performNext
        this.isShowDiscardEdit = true
        return
      }

      this.performNext()
    },
    performNext () {
      this.$emit('onNext')
    },
    close () {
      if (this.isAnyChange) {
        this.confirmDiscardEditCallback = this.performClose
        this.isShowDiscardEdit = true
        return
      }

      this.performClose()
    },
    performClose () {
      this.currentTab = 0
      this.$emit('onClose')
    },
    onCancelDiscardEdit () {
      this.confirmDiscardEditCallback = null
      this.isShowDiscardEdit = false
    },
    onConfirmDiscardEdit () {
      this.isShowDiscardEdit = false
      this.confirmDiscardEditCallback()
      this.confirmDiscardEditCallback = null
    },
    removeArtworkFromExportBox () {
      if (this.currentExportBoxId === 0) {
        this.showNoBoxErrorSnackbar = true
        return
      }

      this.showSuccessSnackbar = false
      this.$store.dispatch('exportBoxes/removeArtworkFromExportBox', { boxId: this.currentExportBoxId, artwork: this.currentArtwork }).then(_ => {
        this.currentArtwork.isInExportBox = false
      }, _ => {
        // todo: error
      })
    },
    addArtworkToExportBox () {
      if (this.currentExportBoxId === 0) {
        this.showNoBoxErrorSnackbar = true
        return
      }
      this.showSuccessSnackbar = false
      this.$store.dispatch('exportBoxes/addArtworkToExportBox', { boxId: this.currentExportBoxId, artwork: this.currentArtwork }).then(_ => {
        this.currentArtwork.isInExportBox = true
      }, _ => {
        // todo: error
      })
    },
    print () {
      const id = this.currentArtwork.type.code + '/' + this.currentArtwork.evidenceNumber

      let detail = this.currentArtwork.techniques.length > 0 ? this.currentArtwork.techniques[0].name : ''

      if (this.currentArtwork.materials.length > 0) {
        if (detail.length > 0) {
          detail += '/'
        }

        detail += this.currentArtwork.materials[0].name
      }

      let dimension = ''

      if (this.currentArtwork.dimensions.length > 0) {
        this.currentArtwork.dimensions[0].items.forEach(d => {
          if (dimension.length > 0) {
            dimension += ' x '
          }

          dimension += d.value

          const dimensionType = this.dimensionList.find(dt => dt.id === this.currentArtwork.dimensions[0].dimensionTypeId)

          if (dimensionType !== null) {
            const dimensionItem = dimensionType.items.find(di => di.id === d.dimensionItemId)

            if (dimensionItem !== null) {
              dimension += ' ' + dimensionItem.unit.name
            }
          }
        })
      }

      ClientAppService.printLabel({
        Identification: id,
        Barcode: id,
        Author: this.currentArtwork.authors.length > 0 ? this.currentArtwork.authors[0].name : '<unknown>',
        Name: this.currentArtwork.name,
        Detail: detail,
        Dimension: dimension
      }).then(_ => {
        this.printSuccessShow = true
      }, _ => {
        this.printErrorShow = true
      })
    }
  },
  watch: {
    'currentArtwork.datingType' (newValue) {
      if (newValue === 0) {
        this.currentArtwork.datingYear = null
        this.currentArtwork.datingYearFrom = null
        this.currentArtwork.datingYearTo = null
      } else if (newValue === 1) {
        this.currentArtwork.datingYearFrom = null
        this.currentArtwork.datingYearTo = null
      } else if (newValue === 2) {
        this.currentArtwork.datingYear = null
      }
    }
  }
}

</script>

<style>
::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #a1a1a1;
}

::-webkit-scrollbar-thumb {
  background-image: linear-gradient(0deg, #555555 0%, #555555 99%);
  box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/ArtWorkEdit.vue